import { jqHeaderMenu } from './modules/jqHeaderMenu';
import { jqHeaderHeight } from './modules/jqHeaderHeight';
import { jsScroll } from './modules/jsScroll';
import { inview_setting } from './modules/inview_setting';
import { smoothScroll } from './modules/smoothScroll';
import { tabletViewport } from './modules/tabletViewport';
import { jqScrollEvents } from './modules/jqScrollEvents';
import { movileTelLink } from './modules/movileTelLink';
import { slider } from './modules/slider';
import { fullpage_setting } from './modules/fullpage_setting';
import { common } from './modules/common';
import { splitText } from './modules/splitText';
import { jqModal } from './modules/jqModal';


//import { gaspScrolltrigger } from './modules/gaspScrolltrigger';
//import { slider } from './modules/slider';
//import { jqAccordion } from './modules/jqAccordion';

// window.addEventListener('load', () => {
//   //crollに応じてアニメーションしたい時
//   scrollmagic();
  
//   //crollによる処理を間引きしたい時
//   // scrollAction();
// });


jqHeaderMenu();
jqHeaderHeight();
jsScroll();
inview_setting();
smoothScroll();
tabletViewport();
jqScrollEvents();
movileTelLink();
slider();
fullpage_setting();
common();
splitText();
jqModal();